export default __webpack_public_path__ + "static/media/fingerprint.9143b33d.svg";